import { UserSubscriptionData } from "./userSubscriptionData";
import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**  Платеж. */
export class ChargeData {
  /**Идентификатор в ДБО. */
  public Id: number = 0;
  /**Статус. */
  public State: number = 0;
  /**Идентификатор во внешней системе */
  public ReferenceId: string = "";
  /**Дата записи в бд */
  public InsertDate: Date = null;
  /**Дата платежа */
  public ChargeDate: Date = null;
  /**Дата окончания действия скидки */
  public DiscountDate: Date = null;
  /**Дата последнего платежа */
  public LastExecDate: Date = null;
  /** Ссылка на картинку. */
  public Sum: number = 0;
  /** Сумма скидки. */
  public DiscountSize: number = 0;
  /**Описание */
  public Description: string = "";
  /**ИНН получателя */
  public ReceiverInn: string = "";
  /**БИК получателя*/
  public ReceiverBik: string = "";
  /**Счет получателя */
  public ReceiverAccount: string = "";
  /**Данные платежа */
  public Data: string = "";
  /**Признак автоматического платежа */
  public AutoExecute: boolean = false;
  /**Подписка пользователя.*/
  public Subscription: UserSubscriptionData = new UserSubscriptionData()
  /**Текущая дата.*/
  public DateTime: any = new Date();
  /** Видимость */
  public Hidden: boolean = false;

  /**
   * Конструктор с загрузкой данных из ответа сервера.
   * @param src данные с сервера
   */
  constructor(src: any) {
    if (src) {
      this.Id = src.Id ?? 0;
      this.State = src.State ?? 1;
      this.Sum = src.AmountToPay ? src.AmountToPay : src.Sum ?? 0;
      this.DiscountSize = src.DiscountSize ?? 0;
      this.ReferenceId = src.ReferenceId ?? "";
      this.InsertDate = parseDate(src.InsertDate) ?? null;
      this.ChargeDate = parseDate(src.ChargeDate) ?? null;
      this.DiscountDate = parseDate(src.DiscountDate) ?? null;
      this.LastExecDate = parseDate(src.LastExecDate) ?? null;
      this.Description = src.Description ?? "";
      this.ReceiverInn = src.ReceiverInn ?? "";
      this.ReceiverBik = src.ReceiverBik ?? "";
      this.ReceiverAccount = src.ReceiverAccount ?? "";
      this.Data = src.Data ?? "";
      this.AutoExecute = src.AutoExecute ?? false;
      this.Subscription = new UserSubscriptionData(src.Subscription);
      this.Hidden = src.Hidden ?? false;
    }
  }

  get SumPayment(): number {
    if (this.HasActiveDiscount)
      {
        return this.Sum - this.DiscountSize;
      }
      return this.Sum; 
  }

  get HasActiveDiscount(): boolean {
    return this.DiscountDate && this.DiscountSize && new Date(this.DiscountDate) > new Date(this.DateTime);
  }

  get IsPaid(): boolean {
    return this.State === 0;
  }
}
